import * as sessionActions from "../actions/sessionActions";
import * as storageKeys from "../enums/storageKeys";
import * as users from "./api/users";
import handleUnknownError from "./handleUnknownError";
import isUnauthenticatedRoute from "./isUnauthenticatedRoute";
import store from "./store";

export default function logout(makeLogoutRequest, useDestinationQuery) {
	if (makeLogoutRequest) {
		users.logout().catch(err => {
			if (__DEV__) {
				console.warn(err);
			}
		});
	}

	sessionStorage.clear();
	localStorage.removeItem(storageKeys.DATA_WARNING_SHOWN);

	if (store.getState().session.isAuthenticated) {
		const action = isUnauthenticatedRoute(window.location.pathname)
			? sessionActions.setAuthenticated(false)
			: sessionActions.logoutAndRedirect(useDestinationQuery);
		return store.dispatch(action).catch(err => handleUnknownError(err));
	}

	return Promise.resolve();
}
